import './App.scss';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import QueryClientWrapper from './utils/queryClientWrapper';
import RoleBasedRedirect from './components/roleBasedRedirect/RoleBasedRedirect';

function App() {
  return (
    <Box className="App" style={{ width: '100%', height: '100%' }}>
      <QueryClientWrapper>
        <RoleBasedRedirect>
          <Outlet />
        </RoleBasedRedirect>
      </QueryClientWrapper>
    </Box>
  );
}

export default App;
